module.exports = __webpack_public_path__ + "img/img2.ae11f761.png";